module.exports = __webpack_public_path__ + "assets/img/7.a48195ef.png";